import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    multiStreamTokenConfigFacebook: {}
};

export const liveStreamSlice = createSlice({
  name: "analytics",
  initialState,
  reducers: {
    updateMultiStreamTokenConfig: (state, action) => {
        state.multiStreamTokenConfigFacebook = {
            ...state.multiStreamTokenConfigFacebook,
            ...action.payload,  // action.payload should contain the new key-value pair(s)
          };    
        }
  },
});

export const { updateMultiStreamTokenConfig} = liveStreamSlice.actions;

export default liveStreamSlice.reducer;
